export const UI_SELECT_OPTIONS = ["Valeur 1", "Valeur 2", "Valeur 3"];
